import createConstant from '../../utils/createConst'
import { API_HOSTNAME } from '../../GlobalConfig'

// import pasarMock from './search-pasar.json'
// import eventMock from './search-event.json'
// import infoMock from './search-info.json'

const SEARCH_PASAR = createConstant('search/SEARCH_PASAR')
const SEARCH_EVENT = createConstant('search/SEARCH_EVENT')
const SEARCH_INFO = createConstant('search/SEARCH_INFO')

const initialState = {
  pasarRequest: false,
  pasarError: '',
  pasar: undefined,
  pasarTotal: 0,
  pasarPagination: {
    next: undefined,
    prev: undefined,
    current: 1,
    perPage: 16,
  },
  eventRequest: false,
  eventError: '',
  event: undefined,
  eventTotal: 0,
  eventPagination: {
    next: undefined,
    prev: undefined,
    current: 1,
    perPage: 12,
  },
  infoRequest: false,
  infoError: '',
  info: undefined,
  infoTotal: 0,
  infoPagination: {
    next: undefined,
    prev: undefined,
    current: 1,
    perPage: 16,
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_PASAR.request:
      return {
        ...state,
        pasarRequest: true,
        pasarError: '',
      }
    case SEARCH_PASAR.failed:
      return {
        ...state,
        pasarRequest: false,
        pasarError: action.error.message,
        pasar: undefined,
      }
    case SEARCH_PASAR.success:
      return {
        ...state,
        pasarRequest: false,
        pasarError: '',
        pasar: action.result.result,
        pasarTotal: action.result.total,
        pasarPagination: action.result.pagination,
      }
    case SEARCH_EVENT.request:
      return {
        ...state,
        eventRequest: true,
        eventError: '',
      }
    case SEARCH_EVENT.failed:
      return {
        ...state,
        eventRequest: false,
        eventError: action.error.message,
        event: undefined,
      }
    case SEARCH_EVENT.success:
      return {
        ...state,
        eventRequest: false,
        eventError: '',
        event: action.result.result,
        eventTotal: action.result.total,
        eventPagination: action.result.pagination,
      }
    case SEARCH_INFO.request:
      return {
        ...state,
        infoRequest: true,
        infoError: '',
      }
    case SEARCH_INFO.failed:
      return {
        ...state,
        infoRequest: false,
        infoError: action.error.message,
        info: undefined,
      }
    case SEARCH_INFO.success:
      return {
        ...state,
        infoRequest: false,
        infoError: '',
        info: action.result.result,
        infoTotal: action.result.total,
        infoPagination: action.result.pagination,
      }
    default:
      return state
  }
}

const options = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  mode: 'cors',
}

export const getSearchPasar = (q, sort) => (dispatch) => {
  dispatch({
    types: SEARCH_PASAR,
    promise: fetch(`${API_HOSTNAME}/v1/search/product?q=${q}&order=${sort}`, options),
  })
}

export const getSearchEvent = (q, sort) => (dispatch) => {
  dispatch({
    types: SEARCH_EVENT,
    promise: fetch(`${API_HOSTNAME}/v1/search/event?q=${q}&order=${sort}`, options),
  })
}

export const getSearchInfo = (q, sort) => (dispatch) => {
  dispatch({
    types: SEARCH_INFO,
    promise: fetch(`${API_HOSTNAME}/v1/search/info?q=${q}&order=${sort}`, options),
  })
}




// WEBPACK FOOTER //
// ./src/modules/Search/index.js